import React, { useEffect, useState } from 'react';
import { Button } from 'primereact/button';

const QuotedMessagePreview = (props) => {
  const [nickname, setNickname] = useState('');
  const [message, setMessage] = useState('');

  useEffect(() => {
    setNickname(props.nickname);
    setMessage(props.message);
  }, [props]);

  return (
    <div className="quoted-message-container flex flex-row align-items-center p-2 border-round-top-lg gap-2 chatroom-surface-200">
      <div className="quoted-message-inner flex-1 opacity-70 border-round-sm px-1" style={{ borderLeft: '5px solid #f55' }}>
        <div className="nickname text-xs text-primary mb-1">{nickname}</div>
        <div className="message">{message}</div>
      </div>
      <div className="close">
        <Button icon="pi pi-times" rounded text severity="danger" size="small" aria-label="Cancel" style={{ width: '2rem', height: '2rem', padding: 0 }} onClick={props.onCancel} />
      </div>
    </div>
  );
};
  
export default QuotedMessagePreview;
